import React from 'react'
import Layout from './../components/Layout/Layout';
import SignUpForm from './../components/SignUpForm/SignUpForm';

function Form() {
  return (
    <Layout>
      <SignUpForm />
    </Layout>
  )
}

export default Form